/**
* Created by Jaime Bonilla Venegas on 2017-06-19.
* Item model for each "Conceptos"
*/
import React, { Component } from 'react';
import FlatButton from 'material-ui/FlatButton';
import Edit from 'material-ui/svg-icons/content/create';
import Trash from 'material-ui/svg-icons/action/delete';
import Block from 'material-ui/svg-icons/content/block';
import Guardar from 'material-ui/svg-icons/content/save';
import { EditableInlineV2 } from '../../../components/text';
import IconButton from 'material-ui/IconButton';
import { setValueIn } from '../../../common/immutable';
import { parsePath, getValueFromSelectList } from '../../../common/helpers';
import { buildErrorsState, validateField, errorsEmpty } from '../../../validations';

const errorsProps = {
    representation: [],
};

//Each rule might correspond with the key for the field to validate
//For now I only use comertialInvoiceNumber
const rules = {
    representation: [{ key: 'required', errorText: 'Campo requerido' }],
};

class Item extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            Status: props.Status,
            errors: { ...errorsProps }
        };
    }


    updateStatus(path, value, path2) {
        //Recalculate errors
        const errors = Object.assign(
            {},
            this.state.errors,
            validateField(rules, path2, value)
        );
        const Status = setValueIn(parsePath(path), value, this.state.Status);
        this.setState({ Status, errors });
    }

    renderButtons(editing, Status, onSave) {
        const { allowUpdate, allowDelete } = this.props;

        return (
            <div className="space-around">
                {
                    editing && <IconButton
                        tooltip="Cancelar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => this.setState({ editing: false, Status, errors: errorsProps })}
                    >
                        <Block />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    editing && <IconButton
                        tooltip="Guardar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            if (errorsEmpty(this.state.errors)) {
                                this.setState({ editing: false });
                                onSave(this.state.Status);
                            }
                        }}
                    >
                        <Guardar />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    (!editing && allowUpdate) && <IconButton
                        tooltip="Editar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            if (!allowUpdate) { return; }
                            this.setState({ Status: Status });
                            this.setState({ editing: true });
                            this.setState({ Status: Status })
                        }}
                    >
                        <Edit />
                    </IconButton>
                }
            </div>
        );
    }


    render() {
        const { editing, errors } = this.state
        const { Status, onSave } = this.props;
        const currentProperties = editing ? this.state.Status : Status;
        const { color, representation, statusName } = currentProperties;

        return (
          <div style={{ margin: '14rem 2rem' }}>
            <div className="col-md-12 margin-top-2 pl0">
                <div className="item-row pb2">
                    <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12 prealertado white-card padding-2 vcenter " style={{ backgroundColor: color }}>
                        <div className="col-lg-5 col-md-5 col-xs-6 vcenter">
                            {/*EditableInline type="text" value="En Proceso" />*/}
                            <EditableInlineV2
                                type="text"
                                editViewActive={editing}
                                value={representation}
                                notify={(value) => this.updateStatus('representation', value.toUpperCase(), 'representation')}
                                errorText={errors.representation.join(' | ')}

                            />
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-6 vcenter">
                            <EditableInlineV2
                                type="autocomplete"
                                value={getValueFromSelectList([
                                    { id: '#d67575', name: 'Rojo' },
                                    { id: '#55d', name: 'Azul' },
                                    { id: '#75d692', name: 'Verde' },
                                    { id: '#d6c075', name: 'Amarillo' },
                                    { id: '#a0a0a0', name: 'Negro' },
                                    { id: '#ff00ff', name: 'Magenta' }
                                ], color).name}
                                editViewActive={editing}
                                items={[
                                    { id: '#d67575', name: 'Rojo' },
                                    { id: '#55d', name: 'Azul' },
                                    { id: '#75d692', name: 'Verde' },
                                    { id: '#d6c075', name: 'Amarillo' },
                                    { id: '#a0a0a0', name: 'Negro' },
                                    { id: '#ff00ff', name: 'Magenta' }
                                ]}
                                notify={(value) => this.updateStatus('color', value.id, 'color')}
                            />
                        </div>
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-8 col-xs-5 vcenter hidden-lg-up">
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-4 col-xs-7 vcenter edit-buttons text-center">
                        {this.renderButtons(editing, Status, onSave)}
                    </div>
                </div>
            </div>
            </div>
        );
    }
}

export default Item;



// WEBPACK FOOTER //
// ./containers/status/components/item.js